'use client';

import { c as _c } from "react/compiler-runtime";
import { EditorViewer } from '@common/components/organism/EditorViewer';
import type { GiftProductDetail } from '@/api/getGiftProductDetail';
import { Image } from '@/components/client';

//* youtube embed url 이 아닐 경우 embed url 로 변환
const getYoutubeEmbedUrl = (url: string): string => {
  const regex = /(?:youtube\.com\/(?:watch\?v=|embed\/)|youtu\.be\/)([\w-]{11})/;
  const match = url.match(regex);
  if (match && match[1]) {
    return `https://www.youtube.com/embed/${match[1]}`;
  }
  return '';
};
interface ContentsProps {
  detailContentInfoList: GiftProductDetail['detailContentInfoList'];
}
export const Contents = t0 => {
  const $ = _c(4);
  const {
    detailContentInfoList
  } = t0;
  let t1;
  if ($[0] !== detailContentInfoList) {
    t1 = detailContentInfoList.map(_temp);
    $[0] = detailContentInfoList;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <section className="relative flex flex-col overflow-y-hidden">{t1}</section>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
};
function _temp(t0, index) {
  const {
    contentType,
    contentUrl,
    autoplayYN
  } = t0;
  switch (contentType) {
    case "IMAGE":
      {
        return <Image key={index} src={contentUrl} alt={"\uC0C1\uD488 \uC0C1\uC138"} width={850} height={600} className="w-full" sizes="(max-width: 768px) 100vw, 850px" />;
      }
    case "VIDEO":
      {
        const embedUrl = getYoutubeEmbedUrl(contentUrl);
        if (!embedUrl) {
          return "";
        }
        const autoplayParam = autoplayYN ? "?autoplay=1" : "";
        return <iframe width="100%" height="500" src={embedUrl + autoplayParam} frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen={true} title="YouTube video" key={index} />;
      }
    case "HTML":
      {
        return <EditorViewer content={contentUrl} key={index} />;
      }
  }
}